import React from 'react';
import Button from './common/Button';
import useIsMobile from '../hooks/useIsMobile';

const ActionButtons = ({
	onRevoke,
	onResume,
	onExit,
	selectedAccounts,
	isDisable,
	customDetails,
}) => {
	const isMobile = useIsMobile();
	const hasActiveConsent = selectedAccounts?.some(
		(account) => account.status === 'ACTIVE'
	);

	return (
		<div
			className="accept-row mb-5"
			style={{
				width: '100%',
				margin: '0 auto',
				marginLeft: isMobile ? '4px' : '13px',
			}}
		>
			<div
				className="pt-2 mb-2 ml-0"
				style={{
					display: 'flex',
					gap: '10px',
					width: isMobile ? '95%' : '39.5%',
					margin: '0 auto',
				}}
			>
				<Button
					onClick={onRevoke}
					disabled={!selectedAccounts?.length || isDisable}
					style={{
						height: customDetails?.btnHeight,
						width: '48%',
						borderRadius: customDetails?.borderRadius,
						
						fontFamily: customDetails?.fontFamily,
					}}
				>
					{isDisable ? (
						<div
							className="snippet"
							style={{ display: 'flex', justifyContent: 'center' }}
							data-title=".dot-pulse"
						>
							<div className="stage">
								<div className="dot-pulse-btn"></div>
							</div>
						</div>
					) : (
						'REVOKE'
					)}
				</Button>
				<Button
					onClick={onResume}
					disabled={!selectedAccounts?.length || isDisable || hasActiveConsent}
					variant="outlined"
					borderColor={customDetails?.btnBorderColor}
					style={{
						height: customDetails?.btnHeight,
						width: '48%',
						borderRadius: customDetails?.borderRadius,
						fontFamily: customDetails?.fontFamily,
					}}
				>
					{isDisable ? (
						<div
							className="snippet"
							style={{ display: 'flex', justifyContent: 'center' }}
							data-title=".dot-pulse"
						>
							<div className="stage">
								<div className="dot-pulse-btn"></div>
							</div>
						</div>
					) : (
						'RESUME'
					)}
				</Button>
			</div>
		</div>
	);
};

export default ActionButtons;
